// Components
import { PerfomanceEssayScreen } from "./performance-essay.component";

export default PerfomanceEssayScreen;
